import { AuthApp } from "../layouts/auth/AuthApp.js";
import { UserAuthApp } from "../layouts/auth/UserAuthApp.js";
import { ProviderAuthApp } from "../layouts/auth/ProviderAuthApp.js";
import { StaffAuthApp } from "../layouts/auth/StaffAuthApp.js";
import { routes } from "../utlis/admin/routes.utlis.js";
import { routes as userroutes } from "../utlis/user/routes.utlis.js";
import { routes as providerroutes } from "../utlis/provider/routes.utlis.js";
import { routes as staffroutes } from "../utlis/staff/routes.utlis.js";
import AdminLogin from "../views/auth/admin/Page.js";
import Home from "../views/auth/user/Home.js";
import Login from "../views/auth/user/Login.js";
import SignUp from "../views/auth/user/SignUp.js";
import UserRegister from "../views/auth/user/UserRegister.js";
import Register from "../views/auth/provider/Register.js";
import StaffRegister from "../views/auth/staff/Register.js";
import About from "../views/common/About.js";
import Privacy from "../views/common/Privacy.js";
import Term from "../views/common/Term.js";
import Subscription from "../views/common/Subscription.js";
import Contact from "../views/common/Contact.js";
import Blog from "../views/auth/user/Blog.js";
import BlogDetail from "../views/auth/user/BlogDetail.js";
import FindJob from "../views/auth/user/FindJob.js";
import FindCare from "../views/auth/user/FindCare.js";
import PageArizona from "../views/auth/caregiver/PageArizona.js";
import PageCalifornia from "../views/auth/caregiver/PageCalifornia.js";
import PageFlorida from "../views/auth/caregiver/PageFlorida.js";
import PageNevada from "../views/auth/caregiver/PageNevada.js";
import PageNewYork from "../views/auth/caregiver/PageNewYork.js";
import PageTexas from "../views/auth/caregiver/PageTexas.js";
import PageGeorgia from "../views/auth/caregiver/PageGeorgia.js";
import PageMaryland from "../views/auth/caregiver/PageMaryland.js";
import PageIllinois from "../views/auth/caregiver/PageIllinois.js";
import PageNewJersey from "../views/auth/caregiver/PageNewJersey.js";
import PageSeekerArizona from "../views/auth/careseeker/PageArizona.js";
import PageSeekerCalifornia from "../views/auth/careseeker/PageCalifornia.js";
import PageSeekerNevada from "../views/auth/careseeker/PageNevada.js";
import PageSeekerFlorida from "../views/auth/careseeker/PageFlorida.js";
import PageSeekerNewYork from "../views/auth/careseeker/PageNewYork.js";
import PageSeekerTexas from "../views/auth/careseeker/PageTexas.js";
import PageSeekerGeorgia from "../views/auth/careseeker/PageGeorgia.js";
import PageSeekerMaryland from "../views/auth/careseeker/PageMaryland.js";
import PageSeekerIllinois from "../views/auth/careseeker/PageIllinois.js";
import PageSeekerNewJersey from "../views/auth/careseeker/PageNewJersey.js";


var AuthRoutes = [
  {
    path: routes.login,
    exact: true,
    layout: AuthApp,
    component: AdminLogin,
  },
  {
    path: userroutes.home,
    exact: true,
    layout: UserAuthApp,
    component: Home,
  },
  {
    path: userroutes.findJob,
    exact: true,
    layout: UserAuthApp,
    component: FindJob,
  },
  {
    path: userroutes.homeFindCare,
    exact: true,
    layout: UserAuthApp,
    component: FindCare,
  },
  {
    path: userroutes.about,
    exact: true,
    layout: UserAuthApp,
    component: About,
  },
  {
    path: userroutes.privacy,
    exact: true,
    layout: UserAuthApp,
    component: Privacy,
  },
  {
    path: userroutes.term,
    exact: true,
    layout: UserAuthApp,
    component: Term,
  },
  {
    path: userroutes.subscription,
    exact: true,
    layout: UserAuthApp,
    component: Subscription,
  },
  {
    path: userroutes.contact,
    exact: true,
    layout: UserAuthApp,
    component: Contact,
  },
  {
    path: userroutes.login,
    exact: true,
    layout: UserAuthApp,
    component: Login,
  },
  {
    path: userroutes.blog,
    exact: true,
    layout: UserAuthApp,
    component: Blog,
  },
  {
    path: userroutes.blogDetail + ":id/:slug",
    exact: true,
    layout: UserAuthApp,
    component: BlogDetail,
  },
  {
    path: userroutes.userRegister,
    exact: true,
    layout: UserAuthApp,
    component: UserRegister,
  },
  {
    path: userroutes.signup,
    exact: true,
    layout: UserAuthApp,
    component: SignUp,
  },
  {
    path: providerroutes.providerRegister,
    exact: true,
    layout: ProviderAuthApp,
    component: Register,
  },
  {
    path: staffroutes.staffRegister,
    exact: true,
    layout: StaffAuthApp,
    component: StaffRegister,
  },
  {
    path: userroutes.careGiverArizona,
    exact: true,
    layout: UserAuthApp,
    component: PageArizona,
  },
  {
    path: userroutes.careGiverCalifornia,
    exact: true,
    layout: UserAuthApp,
    component: PageCalifornia,
  },
  {
    path: userroutes.careGiverFlorida,
    exact: true,
    layout: UserAuthApp,
    component: PageFlorida,
  },
  {
    path: userroutes.careGiverNevada,
    exact: true,
    layout: UserAuthApp,
    component: PageNevada,
  },
  {
    path: userroutes.careGiverNewYork,
    exact: true,
    layout: UserAuthApp,
    component: PageNewYork,
  },
  {
    path: userroutes.careGiverTexas,
    exact: true,
    layout: UserAuthApp,
    component: PageTexas,
  },
  {
    path: userroutes.careGiverGeorgia,
    exact: true,
    layout: UserAuthApp,
    component: PageGeorgia,
  },
  {
    path: userroutes.careGiverMaryland,
    exact: true,
    layout: UserAuthApp,
    component: PageMaryland,
  },
  {
    path: userroutes.careGiverIllinois,
    exact: true,
    layout: UserAuthApp,
    component: PageIllinois,
  },
  {
    path: userroutes.careGiverNewJersey,
    exact: true,
    layout: UserAuthApp,
    component: PageNewJersey,
  },
  {
    path: userroutes.careSeekerArizona,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerArizona,
  },
  {
    path: userroutes.careSeekerCalifornia,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerCalifornia,
  },
  {
    path: userroutes.careSeekerNevada,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerNevada,
  },
  {
    path: userroutes.careSeekerFlorida,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerFlorida,
  },
  {
    path: userroutes.careSeekerGeorgia,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerGeorgia,
  },
  {
    path: userroutes.careSeekerIllinois,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerIllinois,
  },
  {
    path: userroutes.careSeekerMaryland,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerMaryland,
  },
  {
    path: userroutes.careSeekerNewJersey,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerNewJersey,
  },
  {
    path: userroutes.careSeekerNewYork,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerNewYork,
  },
  {
    path: userroutes.careSeekerTexas,
    exact: true,
    layout: UserAuthApp,
    component: PageSeekerTexas,
  },
];

export default AuthRoutes;